export { default as config } from './config'
export { default as locales } from './locales'
export { default as getMessages } from './getMessages'
export { default as getTranslatorWithFallback } from './getTranslatorWithFallback'
